export default __webpack_public_path__ + "static/media/amazon-web-services-black.4e8c5d85.svg";